import Controller from "./tickettypes.controller";
import template from "./tickettypes.html";

const tickettypes = {
  template,
  controller: Controller,
};

export default tickettypes;



// WEBPACK FOOTER //
// ./src/pages/tickettypes/tickettypes.component.js